import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { t } from 'i18next'

import enFlag from '@/assets/image/en.png'
import japanFlag from '@/assets/image/japan.png'
import koreaFlag from '@/assets/image/korea.svg'
import thaiFlag from '@/assets/image/thailand.svg'
import i18n from '@/constant/locales/i18n'
import { setLanguage } from '@/core/store/language/actions'
import { G } from './theme'

/**
 * 하단 언어 상자 — gold8.bet: 170×40 어두운 상자, 마우스를 올리면 위로 목록이 펼쳐진다.
 *   선택 항목은 금색(#ffef77) 바탕. 언어 목록·바꾸는 방법은 기존 LangSelector 와 같다.
 */
const LANGS = [
  { code: 'ja', label: () => t('language.ja'), flag: japanFlag },
  { code: 'en', label: () => 'English', flag: enFlag },
  { code: 'ko', label: () => '한국어', flag: koreaFlag },
  { code: 'th', label: () => 'ภาษาไทย', flag: thaiFlag },
]

const Box = styled.div`
  position: relative;
  width: ${({ $mobile }) => ($mobile ? '150px' : '170px')};
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ $mobile }) => ($mobile ? '10px' : '5px')};
  background: ${({ $mobile }) => ($mobile ? 'transparent' : G.panel2)};
  border: ${({ $mobile }) => ($mobile ? `2px solid #c8960c` : `1px solid ${G.line}`)};
  cursor: pointer;

  &:hover > ul { max-height: 300px; }
`

const Current = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: ${({ $mobile }) => ($mobile ? '#e3a51a' : G.sand)};
  img { width: 18px; height: 18px; border-radius: 50%; object-fit: cover; }
  &::after { content: '▾'; margin-left: 10px; font-size: 14px; color: inherit; }
`

const List = styled.ul`
  position: absolute;
  right: 0;
  bottom: 100%;
  width: 100%;
  max-height: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
  border-radius: 10px;
  background: rgba(8, 8, 7, 0.9);
  transition: max-height 0.5s;
  z-index: 2;
`

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding-left: 24px;
  font-size: 13px;
  color: ${({ $on }) => ($on ? '#000' : G.sand)};
  background: ${({ $on }) => ($on ? G.gold : 'transparent')};
  img { width: 16px; height: 16px; border-radius: 50%; object-fit: cover; }
  &:hover { color: #000; background: ${G.gold}; }
`

export default function GoldLang({ mobile = false }) {
  const dispatch = useDispatch()
  const [lng, setLng] = useState(i18n.language)

  useEffect(() => {
    const on = (l) => setLng(l)
    i18n.on('languageChanged', on)
    return () => i18n.off('languageChanged', on)
  }, [])

  const cur = LANGS.find(l => l.code === lng) || LANGS[0]
  const pick = (code) => {
    void i18n.changeLanguage(code)
    dispatch(setLanguage(code))
  }

  return (
    <Box $mobile={mobile}>
      <Current $mobile={mobile}><img src={cur.flag} alt="" />{cur.label()}</Current>
      <List>
        {LANGS.map(l => (
          <Item key={l.code} $on={l.code === lng} onClick={() => pick(l.code)}>
            <img src={l.flag} alt="" />{l.label()}
          </Item>
        ))}
      </List>
    </Box>
  )
}
